import { render, staticRenderFns } from "./add_journal.vue?vue&type=template&id=fe04948c&scoped=true"
import script from "./add_journal.vue?vue&type=script&lang=js"
export * from "./add_journal.vue?vue&type=script&lang=js"
import style0 from "./add_journal.vue?vue&type=style&index=0&id=fe04948c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe04948c",
  null
  
)

export default component.exports